// Unpublished Work © 2026 Deere & Company.

import * as actions from '../../action-list';
import {DigitalUserSearch} from '../../state/struct/digital-user-search/digital-user-search';
import {Labels} from '../../state/struct/digital-user-search/facets/labels';

const setLabels = (state, action) => Labels.update(state, {
    $merge: action.labels
});

const resetLabels = () => new Labels({});

export const labels = (state = new DigitalUserSearch({}).labels, action = {}) => {
    const actionHandlers = {
        [actions.SET_DIGITAL_USER_SEARCH_LABELS]: setLabels,
        [actions.RESET_DIGITAL_USER_SEARCH]: resetLabels
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
